import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

const ROLES = [
  { id: "ramp_agent",          label: "Ramp Agent"          },
  { id: "baggage_handler",     label: "Baggage Handler"     },
  { id: "fueling_coordinator", label: "Fueling Coordinator" },
  { id: "cleaning_staff",      label: "Cleaning Staff"      },
  { id: "catering_staff",      label: "Catering Staff"      },
  { id: "supervisor",          label: "Supervisor"          },
  { id: "dispatcher",          label: "Dispatcher"          },
];
const STATIONS   = ["DEL", "BOM", "BLR", "HYD", "MAA", "CCU", "AMD", "PNQ"];
const STAFF_NAMES = ["Rahul Sharma", "Amit Verma", "Priya Nair", "Kiran Bhat", "Suresh Pillai", "Divya Kumar", "Naveen Rao", "Arun Menon", "Meera Krishnan", "Ravi Gupta"];

export default function RampLogin({ onLogin }) {
  const [role, setRole]       = useState("ramp_agent");
  const [station, setStation] = useState("DEL");
  const [nameIdx, setNameIdx] = useState(0);
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#07111f] flex flex-col items-center justify-center p-6" style={{ fontFamily: "system-ui, sans-serif" }}>
      <div className="w-full max-w-sm">

        {/* Back to Turnaround */}
        <button
          onClick={() => navigate("/turnaround/board")}
          className="flex items-center gap-1.5 text-slate-500 hover:text-orange-400 text-sm transition-colors mb-6"
          data-testid="back-to-turnaround"
        >
          <ChevronLeft size={16} />
          Back to Turnaround Control
        </button>

        {/* Brand */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-orange-500/20 border border-orange-500/30 rounded-2xl mb-4">
            <span className="text-3xl">✈</span>
          </div>
          <h1 className="text-xl font-black text-white">Ramp Control</h1>
          <p className="text-slate-500 text-sm mt-1">Select your role to start your shift</p>
          <p className="text-[9px] text-slate-600 mt-1 uppercase tracking-widest">Fatigue Shield · Ground Ops</p>
        </div>

        <div className="space-y-4">
          {/* Staff name */}
          <div>
            <label className="text-[10px] uppercase tracking-widest text-slate-500 font-bold block mb-2">Your Name</label>
            <select
              value={nameIdx}
              onChange={e => setNameIdx(Number(e.target.value))}
              className="w-full bg-[#0c1929] border border-slate-600/40 rounded-xl px-4 py-3.5 text-white text-sm focus:border-orange-500/50 focus:outline-none appearance-none"
              data-testid="ramp-name-select"
            >
              {STAFF_NAMES.map((n, i) => <option key={i} value={i}>{n}</option>)}
            </select>
          </div>

          {/* Station */}
          <div>
            <label className="text-[10px] uppercase tracking-widest text-slate-500 font-bold block mb-2">Station</label>
            <div className="grid grid-cols-4 gap-2">
              {STATIONS.map(s => (
                <button
                  key={s}
                  onClick={() => setStation(s)}
                  className={`py-3 rounded-xl text-sm font-bold border transition-all ${station === s ? "bg-orange-500/20 text-orange-400 border-orange-500/30" : "bg-[#0c1929] text-slate-400 border-slate-600/30"}`}
                  data-testid={`station-${s.toLowerCase()}`}
                >
                  {s}
                </button>
              ))}
            </div>
          </div>

          {/* Role */}
          <div>
            <label className="text-[10px] uppercase tracking-widest text-slate-500 font-bold block mb-2">Role</label>
            <div className="space-y-2">
              {ROLES.map(r => (
                <button
                  key={r.id}
                  onClick={() => setRole(r.id)}
                  className={`w-full flex items-center justify-between px-4 py-3.5 rounded-xl border transition-all text-left ${role === r.id ? "bg-orange-500/10 border-orange-500/30 text-white" : "bg-[#0c1929] border-slate-600/30 text-slate-400"}`}
                  data-testid={`role-${r.id}`}
                >
                  <span className="font-semibold text-sm">{r.label}</span>
                  {role === r.id && <span className="text-orange-400 text-xs font-bold">Selected</span>}
                </button>
              ))}
            </div>
          </div>

          <button
            onClick={() => onLogin({ name: STAFF_NAMES[nameIdx], role, station, id: `GS00${nameIdx + 1}` })}
            className="w-full bg-orange-500 hover:bg-orange-400 active:scale-95 text-white font-black text-base py-4 rounded-2xl transition-all mt-2"
            data-testid="ramp-login-btn"
          >
            Start Shift →
          </button>
        </div>
      </div>
    </div>
  );
}
